import { produce } from 'immer'
import { includes, reject } from 'lodash'
import { i18n } from '../i18n/i18n'
import { CustomLabelPrintData } from '../apis/customLabelPrint.api'
import { TableHorizontalData } from '../components/TableHorizontal'

/**
 * Which design a print run came from: "v3" when it matches a recorded version,
 * "Draft" when the label tracks history but the design was never activated,
 * and blank for labels that don't track versions at all.
 */
const versionLabel = (print: CustomLabelPrintData) => {
  if (print.versionNumber) return `v${print.versionNumber}`
  return print.tracksVersions ? i18n('Draft') : ''
}

export default {
  tableHorizontalData (
    customLabelPrints: CustomLabelPrintData[]
  ): TableHorizontalData<CustomLabelPrintData>[] {
    return customLabelPrints.map(print => ({
      ...print,
      versionLabel: versionLabel(print)
    }))
  },

  deleteMany (customLabelPrints: TableHorizontalData<CustomLabelPrintData>[], ids: number[]) {
    return produce(customLabelPrints,
      customLabelPrints => {
        return reject(customLabelPrints, customLabelPrint => {
          return includes(ids, customLabelPrint.id)
        })
      }
    )
  }
}
